<script setup lang="ts">
import { useLocale } from "./useLocale";
useLocale();
</script>
<template>
  <a class="skip-link" href="#main-content">{{
    $i18n.locale === "ro" ? "Salt la conținut" : "Skip to content"
  }}</a
  ><RouterView />
</template>
